import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
      minHeight: 200
    },
    formControl: {
      margin: theme.spacing(1)
    },
    loadInjectionsBtnGrid: {
      textAlign: 'right'
    },
    tableHeader: {
      background: colors.defaultGrey
    },
    tableHeaderFooter: {
      background: colors.defaultGrey
    }
  })
);
